import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "root",
  class: "form-group sog-form-field"
}
const _hoisted_2 = {
  ref: "error",
  class: "error"
}

import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";

interface Props {
  validation1?:SogFormValidationRule,
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'SogFormField',
  props: {
    validation1: { default: undefined }
  },
  setup(__props: any) {



const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default"),
    _createElementVNode("div", _hoisted_2, null, 512)
  ], 512))
}
}

})